import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  InputGroup,
  Col,
  Row,
  Container,
  Modal,
} from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import { Formik } from "formik";
import { getProducts } from "../api/APIUtils";
import FormExtension from "./FormSelection";
import { useHistory } from "react-router-dom";
import AlertDialog from "./Dialog.js";
import Select from "react-select";
import useLocalStorage from "../hooks/useLocalStorage";
import TagsInput from "./TagsInput";

function AppForm(props) {
  const [instance_count, setInstanceCount] = useState(
    _.get(props, "app.instance_count", 0)
  );
  const [instances, setInstances] = useState(
    _.isEmpty(_.get(props, "app.instances"))
      ? []
      : _.get(props, "app.instances")
  );
  const [tags, setTags] = useState(
    _.get(props, "app.tags", [])
  );
  const onChangeValidNumber = (e) => {
    const re = /^[0-9\b]+$/;

    // if value is not blank, then test the regex
    if (_.isNumber(instance_count) && instance_count > e.target.value) {
      let tempArr = [...instances];
      setInstances(_.dropRight(tempArr, instance_count - e.target.value));
    }
    if (e.target.value === "" || re.test(e.target.value)) {
      setInstanceCount(e.target.value);
    }
  };
  const [products, setProducts] = useState([]);
  const [accounts, setAccounts] = useState();
  const [filterproduct, setFilterproduct] = useState([]);
  const [account_id, setAccount_id] = useState();
  const [disable, setDisable] = useState(true);
  const [errorMsgs, setErrorMsgs] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const [localApps] = useLocalStorage("apps", []);
  const history = useHistory();

  // Get all existing tags from all plans for autocompletion
  const existingTags = React.useMemo(() => {
    const allTags = (localApps || []).flatMap(app => app.tags || []);
    return [...new Set(allTags)]; // Remove duplicates
  }, [localApps]);

  useEffect(() => {
    let isApiSubscribed = true;
    getProducts()
      .then((data) => {
        console.log(props);
        console.log(props.isAdmin);
        if (isApiSubscribed) {
          setProducts(data);
          setAccounts(
            _.map(data, function (value) {
              return { label: value.label, id: value.label };
            })
          );
          if (props.edit) {
            const updatedProducts = [
              _.find(data, { label: _.get(props, "app.account_id") }),
            ];
            setFilterproduct(updatedProducts);
            setAccount_id(_.get(props, "app.account_id"));
            setDisable(false);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
    return () => {
      isApiSubscribed = false;
    };
  }, [history, props]);
  //onChangeInArray is for the Instances object change except product_id
  const onChangeInArray = (e) => {
    // if value is not blank, then test the regex

    const identifier = _.split(e.target.id, "-");
    let newArr = [...instances];
    //in the index of list, go ahead and change the key identifier[0] with the value..
    newArr[identifier[1]][identifier[0]] = e.target.value;
    setInstances(newArr);
  };
  //onChangeInArray1 is for the Field Selection
  const onChangeInArray1 = (e) => {
    //will be used later on:
    // const group = products.find((group) =>group.options.find((option) => option.value=== e.target.value.value))
    // const account = group.label
    const identifier = _.split(e.target.label, "-");
    let newArr = [...instances];
    newArr[identifier[1]][identifier[0]] = e.target.value;
    // newArr[identifier[1]]["account_id"] = account
    setInstances(newArr);
  };
  const handleAccount = (e) => {
    console.log('debug 1', e)
    const updatedProducts = [_.find(products, { label: e.id })];
    setFilterproduct(updatedProducts);
    setAccount_id(e.id);
    setDisable(false);
    setInstanceCount(0);
    setInstances([]);
  };

  const [reset, setReset] = useState(false);
  const handleClose = () => {
    setReset(false);
  };
  const handleClosePlanCreation = () => {
    setErrorMsgs([]);
    setShowWarning(false);
  };
  const handleResetNow = () => {
    history.push("/");
  };
  const handleReset = (close, yes) => {
    setReset(true);
  };
  const handleSubmit = (values) => {
    let primary_az_id = _.get(
      instances[0],
      "provisioned_product_id.primary_az_id"
    );
    let secondary_az_id = _.get(
      instances[0],
      "provisioned_product_id.secondary_az_id"
    );
    let planIsValid = true;
    if (_.isEmpty(primary_az_id) || _.isEmpty(secondary_az_id)) {
      planIsValid = false;
      console.log("missing_az_id");
    }
    let nameIsValid = true;
    if (_.isEmpty(_.get(values, "name"))) {
      nameIsValid = false;
    }
    const usedInstaces = _.flattenDeep(
      (localApps || []).map((local) => {
        if (local.id !== _.get(props, "app.id")) {
          return {
            instances: local.instances,
            name: local.name,
            account_id: account_id,
          };
        }
        return false;
      }),
      2
    );
    const monSet = new Set();
    let isInOtherPlan = false;
    let isDelayNotOk = false;
    let productid, hostname, name;
    console.log('debug 2', instances)
    _.each(instances, (instance) => {
      const {
        provisioned_product_id: { value, hostname: host },
      } = instance;
      productid = value;
      hostname = host;
      let tmpPrimary = _.get(instance, "provisioned_product_id.primary_az_id");
      let tmpSecondary = _.get(
        instance,
        "provisioned_product_id.secondary_az_id"
      );
      let label = _.get(instance, "provisioned_product_id.label");

      console.log("Instance Details:");
      console.log("Product ID:", productid);
      console.log("Hostname:", hostname);
      console.log("Primary AZ ID:", tmpPrimary);
      console.log("Secondary AZ ID:", tmpSecondary);
      console.log("Label:", label);
      console.log("debug 3:", usedInstaces)
      console.log("Account id:", account_id, instance, localApps);
      console.log("debug 4:", localApps);
      console.log("-------------------");

      if (_.isEmpty(tmpPrimary)) {
        errorMsgs.push(`the product ${label} didn't have a primary AZ `);
      }
      if (_.isEmpty(tmpSecondary)) {
        errorMsgs.push(`the product ${label} didn't have a secondary AZ `);
      }
      if (tmpPrimary !== primary_az_id || tmpSecondary !== secondary_az_id) {
        planIsValid = false;
      }
      monSet.add(label);
      let delay = _.get(instance, "delay");
      console.log({ delay });
      if (delay < 10 || delay > 1200) {
        isDelayNotOk = true;
      }
      let res = _.find(usedInstaces, (local) =>
        _.some(local.instances, (inst) => {
          const instValue = _.get(inst, "provisioned_product_id.value");
          console.log("Fetched value:", instValue);
          return instValue === instance.provisioned_product_id.value;
        })
      );
      if (!_.isEmpty(res)) {
        ({ name, account_id } = res);
        console.log(`Name: ${name}, Account Id: ${account_id}`);
        isInOtherPlan = true;
      }
    });

    if (monSet.size !== instances.length) {
      errorMsgs.push(`There is a duplicate products in this plan`);
    }
    if (!planIsValid) {
      errorMsgs.push(`The products didn't have the same AZs `);
    }
    if (isInOtherPlan) {
      const errorMessage = (
        <div>
          <p>Selected product is part of other plan, Here are the details</p>
          <div>
            <div>Product ID: {productid}</div>
            <div>Hostname: {hostname}</div>
            <div>Plan Name: {name}</div>
            <div>Account ID: {account_id}</div>
          </div>
          <p>Please select other product</p>
        </div>
      );
      errorMsgs.push(errorMessage);
    }
    // if (isInOtherPlan) {
    //   errorMsgs.push(`A selected product ${productid} with hostname ${hostname} is part of ${name} plan in the account ${account_id}`);
    // }
    if (isDelayNotOk) {
      errorMsgs.push(
        `The delay must be beetwen 10 seconds and 1200 seconds (20 minutes)`
      );
    }
    if (nameIsValid === false) {
      errorMsgs.push(`The DR Plan's name is empty`);
    }
    const myapp = {
      name: _.get(values, "name"),
      primary_az_id: primary_az_id,
      secondary_az_id: secondary_az_id,
      date: _.get(props, "app.date", new Date()),
      id: _.get(props, "app.id", uuidv4()),
      dr_state: _.get(props, "app.dr_state", "primary"),
      instances_recovered: 0,
      instance_count: instance_count,
      instances: instances,
      account_id: account_id,
      tags: tags,
    };
    if (planIsValid && _.isEmpty(errorMsgs)) {
      props.handleOnSubmit(myapp);
    } else {
      setShowWarning(true);
    }
  };
  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{
        name: _.get(props, "app.name"),
        instance_count: instance_count,
        instances: instances,
      }}
    >
      {({ handleSubmit, handleChange, values, touched, isValid, errors }) => (
        <div className={`main-form ${!props.isAdmin && !props.isOperator ? "disabled-form" : ""}`}>
          <Form noValidate onSubmit={handleSubmit}>
            {UserInput({
              validationControl: "validationFormik01",
              type: "text",
              label: "Recovery Plan Name",
              name: "name",
              placeholder: "Name",
              disabled: !props.isAdmin,
              value: _.get(values, "name"),
              touched: touched,
              errors: errors,
              handleChange: handleChange,
            })}
            
            <TagsInput
              tags={tags}
              onChange={setTags}
              disabled={!props.isAdmin && !props.isOperator}
              maxTags={5}
              existingTags={existingTags}
            />
            {!props.edit ? (
              <Form.Group controlId="validationFormik02">
                <Form.Label>Account ID</Form.Label>
                <Select
                  className="accountid"
                  options={accounts}
                  isSearchable
                  placeholder="Account ID"
                  isDisabled={!props.isAdmin}
                  onChange={handleAccount}
                  getOptionValue={(option) => option.label}
                />
              </Form.Group>
            ) : null}
            {UserInput({
              validationControl: "validationFormik03",
              type: "number",
              label: "Instance Count",
              name: "InstanceCount",
              placeholder: "nombre d'instance",
              disabled: !props.isAdmin,
              value: instance_count,
              touched: touched,
              errors: errors,
              handleChange: onChangeValidNumber,
              instance_count: instance_count,
              disabled: disable,
            })}

            {_.toNumber(instance_count) > 0 ? (
              MpiFields(
                instances,
                instance_count,
                onChangeInArray,
                filterproduct,
                onChangeInArray1,
                props
              )
            ) : (
              <div />
            )}
            {reset && (
              <AlertDialog
                isOpen={reset}
                handleReset={handleReset}
                handleClose={handleClose}
                handleResetNow={handleResetNow}
                action="cancel"
              />
            )}
            {
              <Modal
                key="modal"
                show={showWarning}
                onHide={handleClosePlanCreation}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Plan creation</Modal.Title>
                </Modal.Header>
                {errorMsgs.map((msg) => (
                  <Modal.Body>{msg}</Modal.Body>
                ))}
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClosePlanCreation}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            }
            <Container>
              <Row className="justify-content-center">
                <Col xs="auto">
                  <Button
                    variant="danger"
                    type="reset"
                    value="reset"
                    onClick={handleReset}
                    className="submit-btn"
                    size="lg"
                    style={{ marginRight: "8rem" }}
                  >
                    Cancel
                  </Button>
                </Col>
                { (props.isAdmin || props.isOperator) && 
                  <Col xs="auto">
                    <Button
                      variant="success"
                      type="submit"
                      className="submit-btn"
                      size="lg"
                    >
                      Submit
                    </Button>
                  </Col>
                }
              </Row>
            </Container>
          </Form>
        </div>
      )}
    </Formik>
  );
}

const MpiFields = (
  instances,
  instance_count,
  onChangeInArray,
  filterproduct,
  onChangeInArray1,
  props
) => {
  const arrays = [];
  for (let index = 0; index < instance_count; index++) {
    if (_.isEmpty(instances[index]))
      instances[index] = {
        provisioned_product_id: "",
        delay: "",
        launching_order: 0,
      };

    arrays.push(
      <FormExtension
        key={index}
        instances={instances}
        instance_count={instance_count}
        onChangeInArray={onChangeInArray}
        products={filterproduct}
        index={index}
        onChangeInArray1={onChangeInArray1}
        disabled={!props.isAdmin}
      />
    );
  }
  return arrays;
};

const UserInput = (input) => {
  return (
    <Form.Group controlId={input.validationControl}>
      <Form.Label>{input.label}</Form.Label>
      <InputGroup hasValidation>
        <Form.Control
          type={input.type}
          name={input.name}
          className="input-control"
          placeholder={input.placeholder}
          value={input.value}
          onChange={input.handleChange}
          isValid={input.touched[input.value] && !input.errors[input.value]}
          isInvalid={!!input.errors[input.value]}
          disabled={input.disabled}
        />
        <Form.Control.Feedback type="invalid">
          {input.errors[input.value]}
        </Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  );
};
export default AppForm;
